import { render, staticRenderFns } from "./CountryDetailComponent.vue?vue&type=template&id=05079062&scoped=true"
import script from "./CountryDetailComponent.vue?vue&type=script&lang=js"
export * from "./CountryDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./CountryDetailComponent.vue?vue&type=style&index=0&id=05079062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05079062",
  null
  
)

export default component.exports